
import {get, round, sortBy} from 'lodash'


function modifySubmenu(subMenu, { tag, newPriceMultiplier }) {
  if (true) {
    return Object.assign({}, subMenu, {
  
      products: subMenu.products.map((product) => {
        let modgroups = product.modgroups || []
        return Object.assign({}, product, {
          originalPrice: product.price,
          price: Math.floor(product.price * newPriceMultiplier * 100) / 100,
          modgroups: modgroups.map((modgroup) => {
            if (!modgroup.modifiers) { return modgroup }
            return Object.assign({}, modgroup, {
              modifiers: modgroup.modifiers.map((modifier) => {
                return Object.assign({}, modifier, {
                  price: Math.floor(modifier.price * newPriceMultiplier * 100) / 100,
                })
              })
            })
          })
        })
      })
    })
  } else {
    return subMenu
  }
}

export default function applyDiscount(menu) {
  try {

    // 20% price increase for all Pablitos locations — controlled by promoConfig
    const isPablitosMarkup = ['pablitostacosburbank', 'pablitostacosnoho', 'pablitostacosvannuys'].indexOf(menu.shopId) !== -1
    const { pablitosCheckoutPromo } = require('../promoConfig')
    if (isPablitosMarkup && pablitosCheckoutPromo) {
      menu = Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          const subTag = subMenu.tag || ''
          if (subTag.indexOf('tuesday-only') !== -1 || subTag.indexOf('thursdays-only') !== -1 || subTag.indexOf('tuesday-thursdays') !== -1) {
            return subMenu // exempt from markup
          }
          return Object.assign({}, subMenu, {
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []
              return Object.assign({}, product, {
                price: Math.round(product.price * 1.2 * 100) / 100,
                _pablitosPromoMarkup: true,
                modgroups: modgroups.map((modgroup) => {
                  if (!modgroup.modifiers) { return modgroup }
                  return Object.assign({}, modgroup, {
                    modifiers: modgroup.modifiers.map((modifier) => {
                      const updated = Object.assign({}, modifier, {
                        price: Math.round(modifier.price * 1.2 * 100) / 100,
                      })
                      if (Array.isArray(modifier.priceIf)) {
                        updated.priceIf = modifier.priceIf.map((entry) => Object.assign({}, entry, {
                          price: Math.round(entry.price * 1.2 * 100) / 100,
                        }))
                      }
                      return updated
                    })
                  })
                })
              })
            })
          })
        })
      })
    }

    if (["cravestudiocity", 'cravesunset'].indexOf(menu.shopId) !== -1) {


      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (false) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                const productName = get(product, 'name.en', '').toLowerCase()
                const containsChicken = productName.indexOf('chicken') !== -1
                const containsVegan = productName.indexOf('vegan') !== -1
                if (containsChicken && !containsVegan) {
                  const originalDescription = get(product, 'description.en', '')
                  return Object.assign({}, product, {
                    // originalPrice: product.price,
                    price: round(Number(product.price) + 3, 2),
                    // description: {en: "⚠️$3 temporary surcharge is included in chicken dishes due to raising cost. Thanks for your understanding⚠️" + originalDescription}
                  })
                } else {
                  return product
                }
              })
            })
          }
          return subMenu
        })
      })
    }
    // if (["incanorthhills", 'incamaya'].indexOf(menu.shopId) !== -1) {
    //   return Object.assign({}, menu, {
    //     subMenus: menu.subMenus.map((subMenu) => {
    //       if (true) {
    //         return Object.assign({}, subMenu, {
    //           // apply discount
    //           products: subMenu.products.map((product) => {
    //             if (product.name && (product.name.en.toLowerCase().indexOf('saltado') != -1)) {
    //               return Object.assign({}, product, {
    //                 originalPrice: product.price,
    //                 price: Math.floor(product.price * 0.5 * 100) / 100
    //               })
    //             }
    //             return product
    //           })
    //         })
    //       }
    //       return subMenu
    //     })
    //   })
    // }


    if (["pablitostacosvannuys"].indexOf(menu.shopId) !== -1) {
      // const isPromoDate = (new Date().getMonth() === 10) && (new Date().getDate() === 25 && (new Date().getFullYear() === 2025))
      let isPromoDate =  (new Date().getDay() === 2) // every tuesday
      isPromoDate = false
      if (new Date().getFullYear() === 2026 && new Date().getMonth() === 3 && new Date().getDate() === 12) {
        isPromoDate = false
      }

      let modifiedMenu = Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          // check if it is feb 1, 2024
          
          let modifiedSubmenu = null
          if (true) {
            const oldDescription  = get(subMenu, 'description.en', '')
            modifiedSubmenu = Object.assign({}, subMenu, {
              // apply discount
              description: {
                en: oldDescription.replace('chicken mole', 'birria')
              },
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.8 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: function () {
                        let modifiers = modgroup.modifiers.map((modifier) => {
                          // replace modifier name
                          if (modifier.name.indexOf('Mole') !== -1) {
                            return Object.assign({}, modifier, {
                              name: 'Birria'
                            })
                          }
                          if (modifier.name.indexOf('VEGGIE') !== -1) {
                            return Object.assign({}, modifier, {
                              name: 'Veggie'
                            })
                          }
                          // if ((modgroup.name.indexOf('Filling') !== -1) && modifier.name.indexOf('None') !== -1) {
                          //   return Object.assign({}, modifier, {
                          //     name: 'aji de gallina'
                          //   })
                          // }
                          if (modifier.name.indexOf('PASTOR') !== -1) {
                            return Object.assign({}, modifier, {
                              name: 'PASTOR w/ Pineapple'
                            })
                          }
                          return modifier
                        }).filter((modifier) => {return (modifier.name && (modifier.name.indexOf('Fried Oyster') === -1) && (modifier.name.indexOf('NO GREEN SAUCE') === -1) && (modifier.name.indexOf('Green Birria') === -1))})
                        if (modifiers.find((modifier) => modifier.name.toLowerCase() === 'asada')) {
                          modifiers.unshift({
                            id: (modgroup.id + "ajidegallina"), name: "Aji De Gallina (NEW)", price: 0
                          })
                        }
                        return modifiers
                      }()
                    })
                  })
                })
              })
            })
          }
          
          if (isPromoDate && subMenu.tag && subMenu.tag.indexOf('vfiftydeal') !== -1) {
            modifiedSubmenu = Object.assign({}, modifiedSubmenu, {
              // apply discount
              products: modifiedSubmenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.5 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.map((modifier) => {
                        return Object.assign({}, modifier, {
                          price: Math.floor(modifier.price * 0.5 * 100) / 100,
                        })
                      })
                    })
                  })
                })
              })
            })

        
          }

          if (
       false
          ) {
            modifiedSubmenu = Object.assign({}, modifiedSubmenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.8 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.map((modifier) => {
                        return Object.assign({}, modifier, {
                          // price: Math.floor(modifier.price * 0.8 * 100) / 100,
                        })
                      })
                    })
                  })
                })
              })
            })

        
          }

          // modifiedSubmenu = modifySubmenu(modifiedSubmenu, { newPriceMultiplier: 0.75 })

          // console.log(' vannuys modifiedSubmenu', modifiedSubmenu)
  
          return modifiedSubmenu
        })
      })

      // move vfiftydeal to top
      modifiedMenu = Object.assign({}, modifiedMenu, {
        subMenus: sortBy(modifiedMenu.subMenus, (   subMenu) => {
          if (isPromoDate && subMenu.tag && subMenu.tag.indexOf('vfiftydeal') !== -1) {
            return 0
          } else {
            return 1
          }
        })
      })

      // 30% Off vthirtydeal Promo
      const isVthirtyPromo = (new Date().getFullYear() === 2026) && (new Date().getMonth() === 5) && (new Date().getDate() === 16)
      if (isVthirtyPromo) {
        const vthirtyPromoProducts = []
        modifiedMenu.subMenus.forEach((subMenu) => {
          subMenu.products.forEach((product) => {
            if (product.tags && product.tags.indexOf('vthirtydeal') !== -1) {
              vthirtyPromoProducts.push(Object.assign({}, product, {
                id: product.id + '-vthirtydeal',
                originalPrice: product.price,
                price: Math.floor(product.price * 0.7 * 100) / 100,
              }))
            }
          })
        })
        if (vthirtyPromoProducts.length > 0) {
          modifiedMenu = Object.assign({}, modifiedMenu, {
            subMenus: [{
              name: {en: '🔥 30% Off Special - Today Only'},
              description: {en: '30% off select items today only!'},
              products: vthirtyPromoProducts,
              tag: 'vthirtydeal-promo'
            }, ...modifiedMenu.subMenus]
          })
        }
      }

      // 50% Off vfiftydeal Promo
      const isVfiftyPromo = (new Date().getFullYear() === 2026) && (new Date().getMonth() === 5) && (new Date().getDate() === 16)
      if (isVfiftyPromo) {
        const vfiftyPromoProducts = []
        modifiedMenu.subMenus.forEach((subMenu) => {
          subMenu.products.forEach((product) => {
            if (product.tags && product.tags.indexOf('vfiftydeal') !== -1) {
              vfiftyPromoProducts.push(Object.assign({}, product, {
                id: product.id + '-vfiftydeal',
                originalPrice: product.price,
                price: Math.floor(product.price * 0.5 * 100) / 100,
              }))
            }
          })
        })
        if (vfiftyPromoProducts.length > 0) {
          modifiedMenu = Object.assign({}, modifiedMenu, {
            subMenus: [{
              name: {en: '🔥 50% Off Special - Today Only'},
              description: {en: '50% off select items today only!'},
              products: vfiftyPromoProducts,
              tag: 'vfiftydeal-promo'
            }, ...modifiedMenu.subMenus]
          })
        }
      }

      // $1.99 Ensenada Fish Taco Promo - Today Only (2026-05-13)
      const isFishTacoPromo = (new Date().getFullYear() === 2026) && (new Date().getMonth() === 4) && (new Date().getDate() === 13)
      if (isFishTacoPromo) {
        const fishTacoPromoProducts = []
        modifiedMenu.subMenus.forEach((subMenu) => {
          subMenu.products.forEach((product) => {
            const productName = get(product, 'name.en', '').toLowerCase()
            if (productName.indexOf('ensenada') !== -1) {
              fishTacoPromoProducts.push(Object.assign({}, product, {
                id: product.id + '-fishtaco-promo',
                originalPrice: product.price,
                price: 1.99,
              }))
            }
          })
        })
        if (fishTacoPromoProducts.length > 0) {
          modifiedMenu = Object.assign({}, modifiedMenu, {
            subMenus: [{
              name: {en: '🐟 $1.99 Ensenada Fish Tacos - Today Only'},
              description: {en: 'Ensenada style fish tacos for $1.99 — today only!'},
              products: fishTacoPromoProducts,
              tag: 'fishtaco-promo'
            }, ...modifiedMenu.subMenus]
          })
        }
      }

      return modifiedMenu
    }

    if (["pablitostacosnoho"].indexOf(menu.shopId) !== -1) {
      const today = new Date()
      const isPromoDate = (today.getMonth() === 9) && (today.getDate() === 8) && (today.getFullYear() === 2024)
      const isFifteenOffPizzasBurgersDate = (today.getMonth() === 9) && (today.getDate() === 28) && (today.getFullYear() === 2024)
      const categoriesToPrepend = []
      const modifiedMenu = Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          console.log('starting starting')
          if (subMenu.tag && subMenu.tag.indexOf('bigPizzaoff') !== -1) {
            console.log('😱 detected bigPizzaoff')
            const toAppend = Object.assign({}, subMenu, {
              // apply discount
              name: {en: `20% OFF 16" Pizza Special`},
              description: {en: `16" Pizza Special`},
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  id: (product.id + '-16inch'),
                  name: {en: `16" ${product.name.en} Special`},
                  originalPrice: (Number(product.price) + 13),
                  price: Math.floor((Number(product.price) + 13) * 0.8 * 100) / 100,
                  modgroups: modgroups.filter((modgroup) => {return(modgroup.name.indexOf('Size') === -1)}).map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers
                      .filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('12inch') === -1))
                      })
                      .map((modifier) => {
                        return Object.assign({}, modifier, {
                          price: Math.floor(modifier.price * 0.8 * 100) / 100,
                        })
                      })
                    })
                  })
                })
              })
              
            })
            categoriesToPrepend.push(toAppend)
            return(subMenu)
          }
          if (subMenu.tag && subMenu.tag.indexOf('t50off') !== -1) {
            const isTuesday = (today.getDay() === 2)
            if (isTuesday) {
              return Object.assign({}, subMenu, {
                // apply discount
                products: subMenu.products.map((product) => {
                  let modgroups = product.modgroups || []
                  return Object.assign({}, product, {
                    originalPrice: product.price,
                    price: Math.floor(product.price * 0.5 * 100) / 100,
                  })
                })
              })
            }
          }
          if ((subMenu.tag && subMenu.tag.indexOf('30off') !== -1)) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.7 * 100) / 100,
                })
              })
            })
          }
          if (subMenu.tag && subMenu.tag.indexOf('20off') !== -1) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.8 * 100) / 100,
                })
              })
            })
          }
          if (subMenu.tag && subMenu.tag.indexOf('-30off') !== -1) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.7 * 100) / 100,
                })
              })
            })
          }
        
      
          if (
            !subMenu.tag ||
            (subMenu.tag.indexOf('kit') === -1 && subMenu.tag.indexOf('catering') === -1)
          ) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.8 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        if (modifier.name.indexOf('VEGGIE') !== -1) {
                          modifier.name = 'Veggie (Mushroom)'
                        }
                        return (modifier.name && (modifier.name.indexOf('Fried Oyster') === -1)  && (modifier.name.indexOf('NO GREEN SAUCE') === -1) && (modifier.name.indexOf('Green Birria') === -1))
                      })
                    })
                  })
                })
              })
            })
          }
          
            const filtered =  Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.8 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        if (modifier.name.indexOf('VEGGIE') !== -1) {
                          modifier.name = 'Veggie (Mushroom)'
                        }
                        return (modifier.name && (modifier.name.indexOf('Fried Oyster') === -1)  && (modifier.name.indexOf('NO GREEN SAUCE') === -1) && (modifier.name.indexOf('Green Birria') === -1))
                      })
                    })
                  })
                })
              })
            })
          
            return filtered
          })
          
        })
        console.log('categoriesToPrepend', categoriesToPrepend)
        console.log('modifiedMenu', modifiedMenu)
        const newSubMenus= [...categoriesToPrepend, ...modifiedMenu.subMenus]
        let appendedMenu = Object.assign({}, modifiedMenu, {
          subMenus: newSubMenus
        })

        // 30% Off vthirtydeal Promo
        const isVthirtyPromo = (new Date().getFullYear() === 2026) && (new Date().getMonth() === 5) && (new Date().getDate() === 16)
        if (isVthirtyPromo) {
          const vthirtyPromoProducts = []
          appendedMenu.subMenus.forEach((subMenu) => {
            subMenu.products.forEach((product) => {
              if (product.tags && product.tags.indexOf('vthirtydeal') !== -1) {
                vthirtyPromoProducts.push(Object.assign({}, product, {
                  id: product.id + '-vthirtydeal',
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.7 * 100) / 100,
                }))
              }
            })
          })
          if (vthirtyPromoProducts.length > 0) {
            appendedMenu = Object.assign({}, appendedMenu, {
              subMenus: [{
                name: {en: '🔥 30% Off Special - Today Only'},
                description: {en: '30% off select items today only!'},
                products: vthirtyPromoProducts,
                tag: 'vthirtydeal-promo'
              }, ...appendedMenu.subMenus]
            })
          }
        }

        // 50% Off vfiftydeal Promo
        const isVfiftyPromo = (new Date().getFullYear() === 2026) && (new Date().getMonth() === 4) && (new Date().getDate() === 12)
        if (isVfiftyPromo) {
          const vfiftyPromoProducts = []
          appendedMenu.subMenus.forEach((subMenu) => {
            subMenu.products.forEach((product) => {
              if (product.tags && product.tags.indexOf('vfiftydeal') !== -1) {
                vfiftyPromoProducts.push(Object.assign({}, product, {
                  id: product.id + '-vfiftydeal',
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.5 * 100) / 100,
                }))
              }
            })
          })
          if (vfiftyPromoProducts.length > 0) {
            appendedMenu = Object.assign({}, appendedMenu, {
              subMenus: [{
                name: {en: '🔥 50% Off Special - Today Only'},
                description: {en: '50% off select items today only!'},
                products: vfiftyPromoProducts,
                tag: 'vfiftydeal-promo'
              }, ...appendedMenu.subMenus]
            })
          }
        }

        return appendedMenu
    }
    // if (["kokorollburbank"].indexOf(menu.shopId) !== -1) {
    //   return Object.assign({}, menu, {
    //     subMenus: menu.subMenus.map((subMenu) => {
    //       if (true) {
    //         return Object.assign({}, subMenu, {
    //           // apply discount
    //           products: subMenu.products.map((product) => {
    //             let modgroups = product.modgroups || []
    //             return Object.assign({}, product, {
    //               // originalPrice: product.price,
    //               // price: Math.floor(product.price * 0.8 * 100) / 100,
    //               modgroups: modgroups.map((modgroup) => {
    //                 if (!modgroup.modifiers) { return modgroup }
    //                 return Object.assign({}, modgroup, {
    //                   modifiers: modgroup.modifiers.filter((modifier) => {
    //                     return (modifier.name && (modifier.name.indexOf('Beef Bulgogi') === -1) && (modifier.name.indexOf('Shrimp') === -1) && (modifier.name.indexOf('Boba') === -1))
    //                   })
    //                 })
    //               })
    //             })
    //           })
    //         })
    //       }
    //       return subMenu
    //     })
    //   })
    // }

    if (["domenicos"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.9 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Sierra Mist (2L)') === -1)
                        //  && (modifier.name.indexOf('Anchovies') === -1)
                        //  && (modifier.name.indexOf('Prosciutto') === -1)
                        //  && (modifier.name.indexOf('28') === -1)
                        //  && (modifier.name.indexOf('Goat Cheese') === -1)
                        )
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }



    if (["twindragon"].indexOf(menu.shopId) !== -1) {
      const today = new Date()
      const isPromoDate = 
        (today.getFullYear() === 2025 && today.getMonth() === 11 && today.getDate() === 31) ||
        (today.getFullYear() === 2026 && today.getMonth() === 0 && today.getDate() === 1);

      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (isPromoDate) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.9 * 100) / 100,
                  noteDisabled: true,
                  modgroups: modgroups
                    .filter(
                      (modgroup) =>
                        modgroup.required === true ||
                        !(
                          typeof modgroup.name === "string" &&
                          modgroup.name.toLowerCase().includes("tional")
                        )
                    )

                })
              })
            })
          }
          return subMenu
        })
      })
    }

        if (["pablitostacoscorona"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.9 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Mole') === -1)
                        //  && (modifier.name.indexOf('Anchovies') === -1)
                        //  && (modifier.name.indexOf('Prosciutto') === -1)
                        //  && (modifier.name.indexOf('28') === -1)
                        //  && (modifier.name.indexOf('Goat Cheese') === -1)
                        )
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }

    if (["tokyoya"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.9 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Beef Gyoza') === -1)
                        //  && (modifier.name.indexOf('Anchovies') === -1)
                        //  && (modifier.name.indexOf('Prosciutto') === -1)
                        //  && (modifier.name.indexOf('28') === -1)
                        //  && (modifier.name.indexOf('Goat Cheese') === -1)
                        )
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }
    

    if (["-beachwood"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.85 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('12in Gluten-Free Crust') === -1)
                        )
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }
    if (["beachwood"].indexOf(menu.shopId) !== -1) {
      // check if it is saturday or sunday
      const today = new Date()
      const day = today.getDay()
      const isWeekend = (day === 0) || (day === 6)
      const isMorning = (today.getHours() < 16)

      if (isWeekend && isMorning) {  
        return Object.assign({}, menu, {
          subMenus: menu.subMenus.map((subMenu) => {
            if (true) {
              return Object.assign({}, subMenu, {
                // apply discount
                products: subMenu.products.map((product) => {
                  let modgroups = product.modgroups || []
                  return Object.assign({}, product, {
                    // originalPrice: product.price,
                    // price: Math.floor(product.price * 0.8 * 100) / 100,
                    modgroups: modgroups.map((modgroup) => {
                      if (!modgroup.modifiers) { return modgroup }
                      return Object.assign({}, modgroup, {
                        modifiers: modgroup.modifiers.map((modifier) => {
                          if (modifier.name.indexOf('16in') !== -1) {
                            console.log('!!!',modifier)
                            return {
                              id: "16inch-out",
                              name: "(unavailable) 16in *not on weekends before 4pm",
                              price: 0,
                              
                            }
                          }
                          else {
                            return modifier
                          }
                          // return ((modifier.name.indexOf('16in') === -1))
                        })
                      })
                    })
                  })
                })
              })
            }
            return subMenu
          })
        })
      }

      return menu
    }
    if (["omars"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                 // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.8 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Vegan Cheese') === -1)
                        && (modifier.name.indexOf('Red Bell Peppers') === -1)
                      )
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }

    if (["sushidon-"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.8 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Brown Rice') === -1) && (modifier.name.indexOf('Crunchy Tempura Flakes') === -1))
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }
    

    if (["kokorolltorrance"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.8 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Cheddar') === -1) && (modifier.name.indexOf('Dragon') === -1))
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }
    
    if ((menu.shopId.indexOf('kluckin') !== -1) && (menu.shopId.indexOf('kluckinoaks') == -1)) {
   
      console.log('kluckin!')
      menu.subMenus.unshift({"draft":false,"name":{"en":"Special"},"orderIndex":[],"type":"subMenu","shopId":"kluckin","id":"QA6vknKrHm5eDdXW8DpC","products":[{"id":"SFHLzgdXdnEhbv16UC3m","name":{"en":"Kluckin' Ten"},"price":"10","description":{"en":"1 Tender, Kluckin' Mac, Fries."},"modgroups":[{"modifiers":[{"id":"m12","price":null,"name":"No Heat­"},{"name":"Kluckin Mild","id":"m22","price":null},{"id":"m32","name":"Kluckin Hot","price":null},{"name":"Kluckin Fire!","price":null,"id":"m42"}],"id":"we2","name":"How Kluckin Spicy do you want it ?","required":true,"type":"single"},{"type":"buffet","modifiers":[{"name":"Kluckin Sauce","id":"sauce","price":0.5},{"id":"pickles","name":"Extra Pickles","price":0.5}],"id":"extra","name":"Add Ons"}],"photo":{"h":1184,"e":"png","w":1076,"s":"the-kluckin-chicken","id":"kluckin-ten","type":"g"},"sub":"Special","tags":","}]})
      // return Object.assign({}, menu, {
      //   subMenus: 
      // })
    }

    // if ((menu.shopId.indexOf('kluckin') !== -1)) {
    //   return Object.assign({}, menu, {
    //     subMenus: menu.subMenus.map((subMenu) => {
    //       if (true) {
    //         return Object.assign({}, subMenu, {
    //           // apply discount
    //           products: subMenu.products.map((product) => {
    //             let modgroups = product.modgroups || []
    //             return Object.assign({}, product, {
    //               originalPrice: product.price,
    //               price: Math.floor(product.price * 0.9 * 100) / 100,
    //               modgroups: modgroups.map((modgroup) => {
    //                 if (!modgroup.modifiers) { return modgroup }
    //                 return Object.assign({}, modgroup, {
    //                   modifiers: modgroup.modifiers.map((modifier) => {
    //                   return Object.assign({}, modifier, {
    //                     price: Math.floor(modifier.price * 0.9 * 100) / 100,
    //                   })
    //                 })
    //                 })
    //               })
    //             })
    //           })
    //         })
    //       }
    //       return subMenu
    //     })
    //   })
    // }

   

    if (["pablitostacosburbank"].indexOf(menu.shopId) !== -1) {
      let burritoSpecial = false
      let burritoSpecialLoc = false
      const today = new Date()

      const isPromoDate = (today.getMonth() === 8) && (today.getDate() === 12) && (today.getFullYear() === 2024)
      // if it is tuesday
      const isTacokitPromoDate = false // today.getDay() === 2

      const subMenus = menu.subMenus
      .filter((subMenu) => { 
        if (subMenu.tag && subMenu.tag.indexOf('vannuys-only') !== -1) {
          return false
        }
        return true
       })
      .map((subMenu, index) => {
          
        if (isTacokitPromoDate && (subMenu.tag === 'taco-kit')) {
          return Object.assign({}, subMenu, {
            // apply discount
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []
              return Object.assign({}, product, {
                originalPrice: product.price,
                price: Math.floor(product.price * 0.85 * 100) / 100,
                modgroups: modgroups.map((modgroup) => {
                  if (!modgroup.modifiers) { return modgroup }
                  return Object.assign({}, modgroup, {
                    modifiers: modgroup.modifiers.map((modifier) => {
                      return Object.assign({}, modifier, {
                        price: Math.floor(modifier.price * 0.9 * 100) / 100,
                      })
                    })
                  })
                })
              })
            })
          })
        }
        if (subMenu.tag && subMenu.tag.indexOf('10-burrito') !== -1) {
          
          const specialProducts = [] 
          subMenu.products.forEach((product) => {
            const newProduct = Object.assign({}, product, {
              name: {en: `9" ${product.name.en}`},
              // originalPrice: product.price,
              price: Math.min(product.price, 10),
            })
            if (newProduct.price > 9) {
              specialProducts.push(newProduct)
            }
          })
          burritoSpecial = Object.assign({}, subMenu, {
            // apply discount
            name: {en: `9" Burrito Special`},
            description: {en: `9" flour tortilla special.`},
            products: specialProducts
            })
          console.log('burrito', burritoSpecial)
          burritoSpecialLoc = 2
          return subMenu
        }
        
        if (subMenu.tag === '25off') {
          return Object.assign({}, subMenu, {
            // apply discount
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []
              return Object.assign({}, product, {
                originalPrice: product.price,
                price: Math.floor(product.price * 0.75 * 100) / 100,
                modgroups: modgroups.map((modgroup) => {
                  if (!modgroup.modifiers) { return modgroup }
                  return Object.assign({}, modgroup, {
                    modifiers: modgroup.modifiers.map((modifier) => {
                      return Object.assign({}, modifier, {
                        price: Math.floor(modifier.price * 0.75 * 100) / 100,
                      })
                    })
                  })
                })
              })
            })
          })
        }
        if (subMenu.tag && subMenu.tag.indexOf('10off') !== -1) {
          console.log('😱 detected 10offf')
          return Object.assign({}, subMenu, {
            // apply discount
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []
              return Object.assign({}, product, {
                originalPrice: product.price,
                price: Math.floor(product.price * 0.9 * 100) / 100,
                modgroups: modgroups.map((modgroup) => {
                  if (!modgroup.modifiers) { return modgroup }
                  return Object.assign({}, modgroup, {
                    modifiers: modgroup.modifiers.map((modifier) => {
                      return Object.assign({}, modifier, {
                        price: Math.floor(modifier.price * 0.9 * 100) / 100,
                      })
                    })
                  })
                })
              })
            })
          })
        }

 


        if (subMenu.tag && subMenu.tag.indexOf('vfiftyoff') !== -1) {
          
          return Object.assign({}, subMenu, {
            // apply discount
            name: {en: `${subMenu.name.en} 50% off`},
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []
              return Object.assign({}, product, {
                originalPrice: product.price,
                price: Math.floor(product.price * 0.5 * 100) / 100,
              })
            })
          })
        }
       
        if (subMenu.tag && subMenu.tag.indexOf('20off') !== -1) {
          // console.log('detected 50off')
          return Object.assign({}, subMenu, {
            // apply discount
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []
              return Object.assign({}, product, {
                originalPrice: product.price,
                price: Math.floor(product.price * 0.8 * 100) / 100,
              })
            })
          })
        }
        // if (subMenu.tag && subMenu.tag.indexOf('hamburguetza') !== -1) {
        //   // console.log('detected 50off')
        //   return Object.assign({}, subMenu, {
        //     // apply discount
        //     products: subMenu.products.map((product) => {
        //       let modgroups = product.modgroups || []
        //       return Object.assign({}, product, {
        //         originalPrice: product.price,
        //         price: Math.floor(product.price * 0.7 * 100) / 100,
        //       })
        //     })
        //   })
        // }
        if (subMenu.tag && subMenu.tag.indexOf('taquitos') !== -1) {
          // console.log('detected 50off')
          return Object.assign({}, subMenu, {
            // apply discount
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []
              return Object.assign({}, product, {
                // originalPrice: product.price,
                // price: Math.floor(product.price * 0.8 * 100) / 100,
              })
            })
          })
        }

        if (subMenu.tag && subMenu.tag.indexOf('tuesday-only') !== -1) {
          
          return Object.assign({}, subMenu, {
            // apply discount
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []

  
              return Object.assign({}, product, {
                // originalPrice: product.price,
                // price: Math.floor(product.price * 0.80 * 100) / 100,
                modgroups: modgroups.map((modgroup) => {
                  if (!modgroup.modifiers) { return modgroup }
                  return Object.assign({}, modgroup, {
                    modifiers: modgroup.modifiers.filter((modifier) => {
                      console.log(modifier.name)
                      return (modifier.name && (String(modifier.name).indexOf('Fried Oyster') === -1)
                      // && (modifier.name.indexOf('POLLO') === -1)
                      // && (modifier.name.indexOf('Chicken Mole') === -1)
                      )
                    })
                  })
                })
              })
            })
          })
        }

        if (
         true
        ) {
          return Object.assign({}, subMenu, {
            // apply discount
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []

  
              return Object.assign({}, product, {
                // originalPrice: product.price,
                // price: Math.floor(product.price * 0.8 * 100) / 100,
                modgroups: modgroups.map((modgroup) => {
                  if (!modgroup.modifiers) { return modgroup }
                  return Object.assign({}, modgroup, {
                    modifiers: modgroup.modifiers.filter((modifier) => {

                      if (modifier.name.indexOf('VEGGIE') !== -1) {
                        modifier.name = 'Veggie (Mushroom)'
                      }
                      
                      return (modifier.name && (String(modifier.name).indexOf('Fried Oyster') === -1)
                      // && (modifier.name.indexOf('VEGGIE') === -1)
                      // && (modifier.name.indexOf('Chicken Mole') === -1)
                      )
                    })
                  })
                })
              })
            })
          })
        }

        

        return Object.assign({}, subMenu, {
          // apply discount
          products: subMenu.products.map((product) => {
            let modgroups = product.modgroups || []

            // console.log('p tag', product.tags)
            if (product.tags && (product.tags.indexOf('50off--') !== -1)) {
              return Object.assign({}, product, {
                originalPrice: product.price,
                price: Math.floor(product.price * 0.5 * 100) / 100,
              })
            }

            return Object.assign({}, product, {
              // originalPrice: product.price,
              // price: Math.floor(product.price * 0.80 * 100) / 100,
              modgroups: modgroups.map((modgroup) => {
                if (!modgroup.modifiers) { return modgroup }
                return Object.assign({}, modgroup, {
                  modifiers: modgroup.modifiers.filter((modifier) => {
                    console.log(modifier.name)
                    return (modifier.name && (String(modifier.name).indexOf('Fried Oyster') === -1)
                    // && (modifier.name.indexOf('POLLO') === -1)
                    // && (modifier.name.indexOf('Chicken Mole') === -1)
                    )
                  })
                })
              })
            })
          })
        })

        

   
        return subMenu
      })
      // 30% Off vthirtydeal Promo
      const isVthirtyPromo = (new Date().getFullYear() === 2026) && (new Date().getMonth() === 5) && (new Date().getDate() === 16)
      if (isVthirtyPromo) {
        const vthirtyPromoProducts = []
        subMenus.forEach((subMenu) => {
          subMenu.products.forEach((product) => {
            if (product.tags && product.tags.indexOf('vthirtydeal') !== -1) {
              vthirtyPromoProducts.push(Object.assign({}, product, {
                id: product.id + '-vthirtydeal',
                originalPrice: product.price,
                price: Math.floor(product.price * 0.7 * 100) / 100,
              }))
            }
          })
        })
        if (vthirtyPromoProducts.length > 0) {
          subMenus.unshift({
            name: {en: '🔥 30% Off Special - Today Only'},
            description: {en: '30% off select items today only!'},
            products: vthirtyPromoProducts,
            tag: 'vthirtydeal-promo'
          })
        }
      }

      // 50% Off vfiftydeal Promo
      const isVfiftyPromo = (new Date().getFullYear() === 2026) && (new Date().getMonth() === 5) && (new Date().getDate() === 16)
      if (isVfiftyPromo) {
        const vfiftyPromoProducts = []
        subMenus.forEach((subMenu) => {
          subMenu.products.forEach((product) => {
            if (product.tags && product.tags.indexOf('vfiftydeal') !== -1) {
              vfiftyPromoProducts.push(Object.assign({}, product, {
                id: product.id + '-vfiftydeal',
                originalPrice: product.price,
                price: Math.floor(product.price * 0.5 * 100) / 100,
              }))
            }
          })
        })
        if (vfiftyPromoProducts.length > 0) {
          subMenus.unshift({
            name: {en: '🔥 50% Off Special - Today Only'},
            description: {en: '50% off select items today only!'},
            products: vfiftyPromoProducts,
            tag: 'vfiftydeal-promo'
          })
        }
      }

      if (burritoSpecial) {
        // console.log('a', subMenus.splice(2, 0, burritoSpecial))
        const newSubMenus = subMenus.slice()
        newSubMenus.splice(burritoSpecialLoc + 1, 0, burritoSpecial)
        return Object.assign({}, menu, {
          subMenus: newSubMenus
        })
      }
      return Object.assign({}, menu, {
        subMenus: sortBy(subMenus, (   subMenu) => {
          if (subMenu.tag && subMenu.tag.indexOf('vfiftydeal-promo') !== -1) {
            return -1
          }
          if (subMenu.tag && subMenu.tag.indexOf('vthirtydeal-promo') !== -1) {
            return -1
          }
          if ( subMenu.tag && subMenu.tag.indexOf('off') !== -1) {
            return 0
          } else {
            return 1
          }
        })
      })
    }


    if (["pablitosworld!"].indexOf(menu.shopId) !== -1) {
      
      
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          
          if (subMenu.tag === 'family-packs') {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.9 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.map((modifier) => {
                        return Object.assign({}, modifier, {
                          price: Math.floor(modifier.price * 0.9 * 100) / 100,
                        })
                      })
                    })
                  })
                })
              })
            })
          }
 
 
          if (subMenu.tag && subMenu.tag.indexOf('25off') !== -1) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.75 * 100) / 100,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.map((modifier) => {
                        return Object.assign({}, modifier, {
                          price: Math.floor(modifier.price * 0.75 * 100) / 100,
                        })
                      })
                    })
                  })
                })
              })
            })
          }



          if (subMenu.tag && subMenu.tag.indexOf('50off') !== -1) {
            // console.log('detected 50off')
            return Object.assign({}, subMenu, {
              // apply discount
             
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.5 * 100) / 100,
                })
              })
            })
          }
          if (subMenu.tag && subMenu.tag.indexOf('20off') !== -1) {
            // console.log('detected 50off')
            return Object.assign({}, subMenu, {
             
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.8 * 100) / 100,
                })
              })
            })
          }

          if (subMenu.tag && subMenu.tag.indexOf('add-impossible-burger') !== -1) {
            // console.log('detected 50off')
            return subMenu
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.75 * 100) / 100,
                })
              })
            })
          }

          

          return Object.assign({}, subMenu, {
            // apply discount
            products: subMenu.products.map((product) => {
              let modgroups = product.modgroups || []
              return Object.assign({}, product, {
                // originalPrice: product.price,
                // price: Math.floor(product.price * 0.8 * 100) / 100,
                modgroups: modgroups.map((modgroup) => {
                  if (!modgroup.modifiers) { return modgroup }
                  return Object.assign({}, modgroup, {
                    modifiers: modgroup.modifiers.filter((modifier) => {
                      return (modifier.name && (modifier.name.indexOf('Fried Oyster') === -1)
                      // && (modifier.name.indexOf('POLLO') === -1)
                      // && (modifier.name.indexOf('Chicken Mole') === -1)
                      )
                    })
                  })
                })
              })
            })
          })

          

     
          return subMenu
        })
      })
    }

    
    if (["frontierwok-", 'sushidon-', 'muiishi-'].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.9 * 100) / 100,
                  
                })
              })
            })
          }
          return subMenu
        })
      })
    }
    if (["kokorolltorrance"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                if (!product.modgroups) {return product}
                return Object.assign({}, product, {
                  modgroups: product.modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Dragon Fruit') === -1))
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }
    if (["kokorolllacanada"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                if (!product.modgroups) {return product}
                return Object.assign({}, product, {
                  modgroups: product.modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Mango Jelly') === -1) 
                        // && (modifier.name.indexOf('Shrimp Tempura') === -1) 
                        && (modifier.name.indexOf('Strawberry') === -1) 
                        && (modifier.name.indexOf('Guava') === -1) 
                        )
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }

    if (["coralcafe"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          let tag = subMenu.tag || ''
          if (tag.indexOf('no-increase') === -1) {
            return Object.assign({}, subMenu, {
              products: subMenu.products.map((product) => {
                let modgroups = product.modgroups || []
                return Object.assign({}, product, {
                  price: Number(product.price) + 1,
                  modgroups: modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Planks') === -1))
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }

    // if (["lancers"].indexOf(menu.shopId) !== -1) {
    //   return Object.assign({}, menu, {
    //     subMenus: menu.subMenus.map((subMenu) => {
    //       let tag = subMenu.tag || ''
    //       if (tag.indexOf('no-increase') === -1) {
    //         return Object.assign({}, subMenu, {
    //           products: subMenu.products.map((product) => {
    //             if (!Number(product.price)) {
    //               return product
    //             }
    //             return Object.assign({}, product, {
    //               price: Math.floor((Number(product.price) +1) * 100) / 100
    //             })
    //           })
    //         })
    //       }
    //       return subMenu
    //     })
    //   })
    // }

    if (["gourmet88"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          let tag = subMenu.tag || ''
          if (tag.indexOf('no-increase') === -1) {
            return Object.assign({}, subMenu, {
              products: subMenu.products.map((product) => {
                if (!Number(product.price)) {
                  return product
                }
                return Object.assign({}, product, {
                  price: ((Number(product.price) + 1))
                })
              })
            })
          }
          return subMenu
        })
      })
    }
    
  if (["unclereds"].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (true) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                if (!product.modgroups) {return product}
                return Object.assign({}, product, {
                  modgroups: product.modgroups.map((modgroup) => {
                    if (!modgroup.modifiers) { return modgroup }
                    return Object.assign({}, modgroup, {
                      modifiers: modgroup.modifiers.filter((modifier) => {
                        return (modifier.name && (modifier.name.indexOf('Spinach') === -1))
                      })
                    })
                  })
                })
              })
            })
          }
          return subMenu
        })
      })
    }
    // if (["pablitostacosburbank"].indexOf(menu.shopId) !== -1) {
    //   return Object.assign({}, menu, {
    //     subMenus: menu.subMenus.map((subMenu) => {
    //       if (true) {
    //         return Object.assign({}, subMenu, {
    //           // apply discount
    //           products: subMenu.products.filter((product) => {
    //             let {name, description} = product
    //             name = (name && name.en) || ''
    //             description = (description && description.en) || ''
    //             const noSausageName = (name.toLowerCase().indexOf('chicharron') === -1)
    //             const noSausageDesc = description.toLowerCase().indexOf('chicharron') === -1
    //             return noSausageName && noSausageDesc
    //           })
    //         })
    //       }
    //       return subMenu
    //     })
    //   })
    // }


    if (["newdeal", 'wildcarvery'].indexOf(menu.shopId) !== -1) {
      return Object.assign({}, menu, {
        subMenus: menu.subMenus.map((subMenu) => {
          if (subMenu.tag && (subMenu.tag.indexOf('discount-50-off') !== -1)) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.5 * 100) / 100
                })
              })
            })
          }
          if (subMenu.tag && (subMenu.tag.indexOf('discount-30-off') !== -1)) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                return Object.assign({}, product, {
                  originalPrice: product.price,
                  price: Math.floor(product.price * 0.7 * 100) / 100
                })
              })
            })
          }
          if (subMenu.tag && (subMenu.tag.indexOf('wine') !== -1)) {
            return Object.assign({}, subMenu, {
              // apply discount
              products: subMenu.products.map((product) => {
                return Object.assign({}, product, {
                  // originalPrice: product.price,
                  // price: Math.floor(product.price * 0.8 * 100) / 100
                })
              })
            })
          }
          // if (subMenu.tag && (subMenu.tag.indexOf('spirits') !== -1)) {
          //   return Object.assign({}, subMenu, {
          //     // apply discount
          //     products: subMenu.products.map((product) => {
          //       return Object.assign({}, product, {
          //         originalPrice: product.price,
          //         price: Math.floor(product.price * 0.75 * 100) / 100
          //       })
          //     })
          //   })
          // }
          return subMenu
        })
      })
    }


    return menu
  } catch (e) {
    console.log(e)
    return menu
  }

}
